import { EmptyState } from 'app/agriculture/components/EmptyState/EmptyState';
import { Note } from 'app/agriculture/queries/notes/types/Note';
import { NoteRow } from './NoteRow';
import './NoteListComponent.scss';

interface NoteListProps {
    notes: Note[];
    hasFilterApplied?: boolean;
}

export function NoteListComponent({ notes, hasFilterApplied = false }: NoteListProps) {
    return (
        <div className="NoteList" data-testid="NoteList">
            {notes.length === 0 && (
                <EmptyState
                    message={
                        hasFilterApplied
                            ? 'Your search returned no results'
                            : 'There are currently no notes'
                    }
                />
            )}
            {notes.length > 0 && notes.map((note) => <NoteRow note={note} key={note.id} />)}
        </div>
    );
}
